import { WarningCircle, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

export default function AlertsPanel({ open, onOpenChange, alerts }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-[400px] sm:w-[540px]">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <WarningCircle size={24} className="text-yellow-600" />
            Alertas de Stock Bajo
          </SheetTitle>
        </SheetHeader>
        <div className="mt-6 space-y-3">
          {alerts.length === 0 ? (
            <div className="text-center py-8 text-slate-500">
              <WarningCircle size={48} className="mx-auto mb-4 text-slate-300" />
              <p>No hay alertas de stock bajo</p>
              <p className="text-sm mt-1">¡Todo está en orden!</p>
            </div>
          ) : (
            <>
              <p className="text-sm text-slate-600 mb-4">
                Los siguientes artículos tienen stock por debajo del nivel previsto:
              </p>
              {alerts.map((alert, idx) => (
                <div
                  key={idx}
                  data-testid={`alert-item-${idx}`}
                  className="flex items-start gap-3 p-4 bg-yellow-50 border border-yellow-200 rounded-lg"
                >
                  <WarningCircle size={20} className="text-yellow-600 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-yellow-800">{alert}</p>
                </div>
              ))}
              <p className="text-xs text-slate-500 mt-4">
                Puedes ajustar el stock previsto en la pestaña de Inventario para modificar estos umbrales.
              </p>
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
